import { render, staticRenderFns } from "./confirmationModal.vue?vue&type=template&id=04666782"
import script from "./confirmationModal.vue?vue&type=script&lang=js"
export * from "./confirmationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports